import Vue from 'vue';
import './public-path';
import axios from './router/axios';
import VueAxios from 'vue-axios';
import App from './App';
import router from './router/router';
import './permission'; // 权限
import './cache';//页面缓存
import store from './store';
import { loadStyle } from './util/util'
import * as urls from '@/config/env';
import Element from 'element-ui';
import { Table, Autocomplete } from 'rich_element';
import 'rich_element/lib/theme-chalk/index.css';
import '@/basic-common/components/autoRegister.js' // 自动挂载公共组件
import {
  iconfontUrl,
  iconfontVersion
} from '@/config/env';
import i18n from './lang'; // Internationalization
import './styles/common.scss';
import func from '@/util/func'
import thirdRegister from './components/third-register/main';
import flowDesign from './components/flow-design/main';
import avueUeditor from 'avue-plugin-ueditor';
import website from '@/config/website';
import crudCommon from '@/mixins/crud';
import dialogDrag from '@/basic-common/util/dialog-drag';
import ellipsis from '@/basic-common/util/ellipsis';
// 业务组件
import tenantPackage from './views/system/tenantpackage';
// 优化message提示框
import resetMessage from '@/basic-common/util/reset-message.js';
import confirm from '@/basic-common/util/confirm.js';
// 注册全局crud驱动

import Vue2OrgTree from 'vue2-org-tree'
import 'vue2-org-tree/dist/style.css'


window.$crudCommon = crudCommon;


import dataV from '@jiaminghi/data-view'

Vue.use(dataV)

Vue.prototype.$func = func;

Vue.use(Vue2OrgTree)
// 加载Vue拓展
Vue.use(router);
Vue.use(VueAxios, axios);
Vue.use(Element, {
  size: 'small',
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(window.AVUE, {
  size: 'small',
  tableSize: 'small',
  calcHeight: 65,
  i18n: (key, value) => i18n.t(key, value)
});
// rich_element组件
Vue.component('ElTable', Table);
Vue.component('ElAutocomplete', Autocomplete);

// // 高德离线地图

//图片展示

// 全局自定义指令 注册两个指令 原因avue混乱使用 dialogdrag dialogDrag 导致问题， 业务开发统一使用dialogDrag
Vue.directive('dialogdrag', dialogDrag);
Vue.directive('dialogDrag', dialogDrag);
Vue.directive('ellipsis', ellipsis);
// Element message + confirm 消息框优化
Vue.prototype.$message = resetMessage;
Vue.prototype.$confirm_danger = confirm.danger;
Vue.prototype.$confirm_primary = confirm.primary;

// 注册全局容器
Vue.component('thirdRegister', thirdRegister);
Vue.component('avueUeditor', avueUeditor);
Vue.component('flowDesign', flowDesign);
Vue.component('tenantPackage', tenantPackage);
// 加载相关url地址
Object.keys(urls).forEach(key => {
  Vue.prototype[key] = urls[key];
});
// 加载NutFlow
Vue.use(window.WfDesignBase);
// 加载bpmn工作流插件
Vue.use(window.WfBmModeler);
// 加载大屏设计器插件
Vue.use(window.BigScreenDesigner);
// 加载website
Vue.prototype.website = website;
// 动态加载阿里云字体库
iconfontVersion.forEach(ele => {
  loadStyle(iconfontUrl.replace('$key', ele));
});

Vue.config.productionTip = false;

Vue.config.devtools = true

import WaterMark from '@/components/WaterMark.vue'


let _APP = null
let offGlobalStateChange = null
let offWindowRouteChange = null
let microRouterBase = ''
let microRoutesReady = null

Vue.component('WaterMark', WaterMark)

// new Vue({
//   router,
//   store,
//   i18n,
//   render: h => h(App)
// }).$mount('#app');

function trimTrailingSlash(path = '') {
  return path.replace(/\/+$/, '')
}

function normalizeMicroSubRoute(path = '', routerBase = '') {
  let target = (path || '').trim()
  const firstPage = (website.fistPage && website.fistPage.value) || '/wel/index'
  if (!target) return firstPage

  // 兼容 #/xxx、xxx 这两类输入
  target = target.replace(/^#/, '')
  if (!target.startsWith('/')) {
    target = `/${target}`
  }

  // 若收到的是主应用地址（如 /micro/app2#/wel/index），优先取 hash 内路由
  const hashIndex = target.indexOf('#')
  if (hashIndex >= 0) {
    const hashPath = target.slice(hashIndex + 1).trim()
    if (hashPath) {
      target = hashPath.startsWith('/') ? hashPath : `/${hashPath}`
    } else {
      target = '/'
    }
  }

  // 剥离主应用微前端基座前缀（如 /micro/app2）
  const base = trimTrailingSlash(routerBase || '')
  if (base && target.toLowerCase().startsWith(base.toLowerCase())) {
    const rest = target.slice(base.length)
    target = rest ? (rest.startsWith('/') ? rest : `/${rest}`) : firstPage
  }
  if (target === '/' || target === '/index') {
    target = firstPage
  }

  return target || firstPage
}

function getMicroSubRouteFromLocation() {
  const hash = (window.location.hash || '').replace(/^#/, '');
  if (hash) {
    const pathname = (window.location.pathname || '').trim()
    const base = trimTrailingSlash(microRouterBase)
    if (base && pathname.toLowerCase().startsWith(base.toLowerCase()) && hash === '/404') {
      return '/'
    }
    return hash.startsWith('/') ? hash : `/${hash}`;
  }
  if (microRouterBase) {
    const base = trimTrailingSlash(microRouterBase)
    const pathname = (window.location.pathname || '').trim()
    if (base && pathname.toLowerCase().startsWith(base.toLowerCase())) {
      const rest = pathname.slice(base.length)
      if (!rest || rest === '/' || rest === '/index') return '/'
      return rest.startsWith('/') ? rest : `/${rest}`
    }
  }
  return '/';
}

function replaceMicroRoute(path) {
  const targetPath = normalizeMicroSubRoute(path || getMicroSubRouteFromLocation(), microRouterBase);
  if (!targetPath || router.currentRoute.fullPath === targetPath) return;
  const promise = ensureMicroRoutes().then(() => router.replace(targetPath));
  if (promise && promise.catch) {
    promise.catch((err) => {
      if (!err || err.name === 'NavigationDuplicated') return;
      console.error('[微应用] 路由同步失败', err);
    });
  }
}

function ensureMicroRoutes() {
  if (!window.__POWERED_BY_QIANKUN__) {
    return Promise.resolve()
  }
  if (microRoutesReady) {
    return microRoutesReady
  }
  microRoutesReady = store.dispatch('GetMenu').then((data) => {
    if (data && data.length) {
      router.$avueRouter.formatRoutes(data, true)
    }
  }).catch((err) => {
    console.error('[微应用] 菜单路由加载失败', err)
  })
  return microRoutesReady
}

function bindMicroRouteSync(props = {}) {
  unbindMicroRouteSync();
  microRouterBase = props.routerBase || ''

  const microActions = props.mainActions || props.actions || {};
  const onGlobalStateChange = props.onGlobalStateChange || microActions.onGlobalStateChange;
  const offStateChange = props.offGlobalStateChange || microActions.offGlobalStateChange;

  if (typeof onGlobalStateChange === 'function') {
    const dispose = onGlobalStateChange((state) => {
      const routePath = state && (state.microSubRoute || (state.$route && state.$route.microSubRoute));
      if (routePath) {
        replaceMicroRoute(routePath);
      }
    }, true);
    offGlobalStateChange = typeof dispose === 'function'
      ? dispose
      : (typeof offStateChange === 'function' ? offStateChange : null);
  }

  const syncFromWindow = () => replaceMicroRoute();
  window.addEventListener('hashchange', syncFromWindow);
  window.addEventListener('popstate', syncFromWindow);
  offWindowRouteChange = () => {
    window.removeEventListener('hashchange', syncFromWindow);
    window.removeEventListener('popstate', syncFromWindow);
  };

  syncFromWindow();
}

function unbindMicroRouteSync() {
  if (typeof offGlobalStateChange === 'function') {
    offGlobalStateChange();
  }
  if (typeof offWindowRouteChange === 'function') {
    offWindowRouteChange();
  }
  offGlobalStateChange = null;
  offWindowRouteChange = null;
  microRouterBase = ''
}

function render(props = {}) {
  const { container, microSubRoute } = props;
  _APP = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  })

  _APP.$mount(container ? container.querySelector('#sub-app') : '#sub-app');
  if (microSubRoute) {
    replaceMicroRoute(microSubRoute);
  }
  return _APP;
}

if (!window.__POWERED_BY_QIANKUN__) {
  render();
}else{
  window.Vue3 = window.Vue;
  delete window.Vue

}
window[`outIn`] = {

  bootstrap: async () => {
  },
  mount: async (props) => {
    bindMicroRouteSync(props);
    return render(props);
  },
  unmount: async () => {
    unbindMicroRouteSync();
    _APP && _APP.$destroy();
    _APP = null;
  }
}






